export const moduleName = 'email-enquiry';